<template>
  <li>
    <NuxtLink :to="{ path: pageLink }">
      {{ displayTitle }}
    </NuxtLink>
    <span class="divide"> / </span>
  </li>
</template>

<script setup lang="ts">
import type { PageStoryblok } from '~/types/storyblok'

const props = defineProps<{ blok: PageStoryblok }>()

const displayTitle = computed(() => {
  return props.blok?.content?.intro?.[0]?.title || props.blok?.name || ''
})
const pageLink = computed(() => '/' + props.blok?.full_slug)
</script>
